var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPatients(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 9.1 9.18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#555;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_2-2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "jcpVPP.tif"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M3.53,0a1,1,0,0,1,.62.57A.72.72,0,0,0,4.84,1H8.41A1,1,0,0,1,8.76,1a.53.53,0,0,1,.33.45c0,.19,0,.38,0,.59a1.68,1.68,0,0,0-.93-.15H4.88a.28.28,0,0,1-.28-.17A1.34,1.34,0,0,0,3.28.94c-.8,0-1.61,0-2.41,0A1.51,1.51,0,0,0,0,1.1C0,.88,0,.68,0,.49A.52.52,0,0,1,.34.05L.45,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M0,9.18V3.75a1.09,1.09,0,0,1,0-.31A.54.54,0,0,1,.55,3Q2,3,3.43,3a.68.68,0,0,1,.56.3,1.76,1.76,0,0,1,.14.23A.75.75,0,0,0,4.84,4H8.45a.57.57,0,0,1,.64.65V9.18Zm4-.94V8.17c-.05-.41-.1-.83-.16-1.25a.51.51,0,0,0-.32-.44l-.36-.15a.1.1,0,0,0-.14,0l-.25.29L2.46,7l-.29-.33c-.1-.11-.2-.29-.32-.31s-.28.1-.42.16a.53.53,0,0,0-.32.45l-.06.49C1,7.7,1,8,1,8.24ZM2.47,4.45a.81.81,0,1,0,0,1.62.81.81,0,0,0,0-1.62ZM4.84,6.54V7.1h3.3V6.54Zm0-1.14V6H7V5.4ZM6.31,7.68v.56H8.14V7.68Zm-1.47,0v.56h.89V7.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M9.09,3.56a1.41,1.41,0,0,0-.75-.15H4.87a.28.28,0,0,1-.27-.16,1.32,1.32,0,0,0-1.31-.79c-.85,0-1.69,0-2.53,0A1.41,1.41,0,0,0,0,2.61C0,2.39,0,2.19,0,2a.54.54,0,0,1,.55-.47H3.41A.68.68,0,0,1,4,1.84a.18.18,0,0,1,0,.07.9.9,0,0,0,1,.56c1.15,0,2.31,0,3.46,0a.56.56,0,0,1,.61.61C9.1,3.23,9.09,3.38,9.09,3.56Z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPatients);
export default __webpack_public_path__ + "static/media/Patients.8a92fb98380e12c9cd684f4eeebc27ef.svg";
export { ForwardRef as ReactComponent };